import React, { Component } from 'react'
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Card, CardBody } from 'reactstrap'
import { Link } from 'react-router-dom'
import Table from '../common/Table'
import { getUsers } from '../../actions/userAction'
import isEmpty from '../../validation/is-empty';

class listUsers extends Component {

  componentDidMount() {
    this.props.getUsers()
  }
  render() {
    const users = isEmpty(this.props.users.users) ? [] : this.props.users.users
    return (
      <div className="main-content">
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Danh sach Sinh viên</h5>
                  <div>
                    <Link to="/admin/all" className="btn btn-sm btn-default">Xem thêm</Link>
                  </div>
                </div>
                <div className="m-t-30">
                  <Table columns={[
                    {
                      id:'selection',
                      Header:({getToggleAllRowsSelectedProps}) => (
                        <div>
                          <input type='checkbox' {...getToggleAllRowsSelectedProps()}/>
                        </div>
                      ),
                      Cell: ({ row }) => (
                        <div>
                          <input type="checkbox" {...row.getToggleRowSelectedProps()} />
                        </div>
                      )
                    },
                    {
                      Header: 'ID',
                      accessor: '_id',
                    },
                    {
                      Header: 'Ho va Ten',
                      accessor: 'HoTen',
                    },
                    {
                      Header: 'Email',
                      accessor: 'email',
                    },
                    {
                      Header: 'Dien Thoai',
                      accessor: 'DienThoai',
                    },
                    {
                      Header: 'DiDong',
                      accessor: 'DiDong',
                    }
                  ]} data={users} getTrProps={(state,rowInfo) => {
                    console.log(state['New State'])
                  }}/>
                </div>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </div>
    )
  }
}

listUsers.propTypes = {
  getUsers: PropTypes.func.isRequired,
  users: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  users: state.users
});


export default connect(mapStateToProps, { getUsers })(listUsers)


// WEBPACK FOOTER //
// ./src/components/pages/listUsers.js